import { apiService } from '.';

export interface SharepointLoginResponse {
    authenticated: boolean;
    authUrl?: string;
}

export interface Site {
    id: string;
    displayName: string;
}

export interface Drive {
    id: string;
    name: string;
}

export interface FileOrFolder {
    id: string;
    name: string;
    folder?: any;
    file?: any;
}

export interface Revoke {
    success: boolean;
}

export const asyncSharepointGetAuthUrl = async (
    redirectUrl: string
): Promise<SharepointLoginResponse> => {
    const response = await apiService.get<SharepointLoginResponse>(
        `/api/sharepoint-graph/login?redirectUrl=${encodeURIComponent(
            redirectUrl
        )}`
    );
    return response;
};

export const asyncSharepointGetSites = async (): Promise<any> => {
    const response = await apiService.get<Site[]>(
        `/api/sharepoint-graph/sites`
    );
    return response;
};

export const asyncSharepointGetDrives = async (
    siteId: string | null
): Promise<Drive[]> => {
    const response = await apiService.get<Drive[]>(
        `/api/sharepoint-graph/sites/${siteId}/drives`
    );
    return response;
};

export const asyncSharepointGetFiles = async (
    siteId: string | null,
    driveId: string | null,
    folderId?: string
): Promise<FileOrFolder[]> => {
    let url = `/api/sharepoint-graph/files/${siteId}/${driveId}`;
    if (folderId) {
        url += `/${folderId}`;
    }
    const response = await apiService.get<FileOrFolder[]>(url);
    return response;
};

export const asyncSharepointRevokeAccess = async (): Promise<void> => {
    await apiService.post('/api/sharepoint-graph/revoke', {});
};

export const asyncSharepointGetMyDriveRoot = async (): Promise<
    FileOrFolder[]
> => {
    const response = await apiService.get<FileOrFolder[]>(
        `/api/sharepoint-graph/me/drive/root/children`
    );
    return response;
};

export const asyncSharepointGetDriveItemChildren = async (
    itemId: string
): Promise<FileOrFolder[]> => {
    const response = await apiService.get<FileOrFolder[]>(
        `/api/sharepoint-graph/me/drive/items/${itemId}/children`
    );
    return response;
};

export const asyncRevokeToken = async (): Promise<Revoke> => {
    const response = await apiService.get<Revoke>(
        '/api/sharepoint-graph/revoke-token'
    );
    return response;
};
